module.exports = __webpack_public_path__ + "img/print_check_unchecked.b4d0f27b.svg";